import React, { useCallback } from 'react'
import { Chip } from '@material-ui/core'
import { AnimalProps } from 'src/@types/Animal'
import { Actions } from 'src/components/CustomTable/components/Actions'
import { useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'

export const useAnimalHeaderTable = () => {
  const navigate = useNavigate()

  const goToAnimalDetails = useCallback((id: string) => {
    navigate(ROUTES.ANIMAL.toDetails(id))
  }, [])

  const tableHeader = [
    {
      property: 'nome',
      name: 'NOME',
      format: (value: string | null) => (value?.toLowerCase() !== 'null' ? value : '-'),
      textAlign: 'center'
    },
    {
      property: 'cdn',
      name: 'NÚMERO',
      format: (value: string | null) => (value?.toLowerCase() !== 'null' ? value : '-'),
      textAlign: 'center'
    },
    {
      property: 'sexo',
      name: 'SEXO',
      format: (value: string | null) => (value === 'F' ? 'Fêmea' : value === 'M' ? 'Macho' : '-'),
      textAlign: 'center'
    },
    {
      property: 'raca',
      name: 'RAÇA',
      format: (value: string | null) => (value?.toLowerCase() !== 'null' ? value : '-'),
      textAlign: 'start'
    },
    {
      property: 'rgn',
      name: 'RGN',
      format: (value: string | null) => (value?.toLowerCase() !== 'null' ? value : '-'),
      textAlign: 'center'
    },
    {
      property: 'categoria',
      name: '',
      textAlign: 'center',
      compoment: (item: AnimalProps) => {
        return (
          item.categoria &&
          item.categoria !== 'AT' && (
            <Chip
              label={item.categoria === 'VD' ? 'Animal vendido' : 'Animal morto'}
              variant='default'
              color='primary'
              style={{
                borderRadius: 5,
                backgroundColor: 'rgba(0,0,0,0.8)',
                color: '#fff',
                letterSpacing: 0.5
              }}
            />
          )
        )
      }
    },
    {
      size: 154,
      property: 'status',
      textAlign: 'center',
      name: '',
      isMobileHidden: true,
      compoment: (item: AnimalProps) => (
        <Actions
          onClick={() => {
            goToAnimalDetails(item?.id!)
          }}
        />
      )
    }
  ]

  return {
    tableHeader,
    goToAnimalDetails
  }
}
